import { query } from '../../utils/query';

export const getOrderPacksRequest = (params = {}) => {
  return query({
    uri: 'api/v1/admin/order-packs',
    params
  });
};